import { useOutletContext, useParams } from "react-router-dom";
import ProfileForm from "../../components/Profile/ProfileForm";
import { useModal } from "../../hooks/use-modal.jsx";
import { Profile } from "../../models/profile";
import { useCandidatProfiles } from "../../hooks/use-profiles-indiv";

export default function CandidatProfileAddPage({ isGarant }) {
  const { profileId } = useParams();
  const [Modal, closeModal] = useModal(true);

  const { createProfile } = useCandidatProfiles();
  const { onProfileSubmitted } = useOutletContext();

  return (
    <ProfileForm
      onSubmit={async (data) => {
        const profile = Profile.create(data);
        if (isGarant) {
          profile.garantor_of = parseInt(profileId);
        }
        const newProfile = await createProfile(profile);
        closeModal();
        onProfileSubmitted(newProfile.id, !isGarant);
      }}
      modal={Modal}
      isGarant={isGarant}
      isCandidat
    />
  );
}
